const HTML5_CANVAS_FORMAT = 'html5 canvas';

/**
 * Maps the user-facing format name to the identifier the backend expects.
 * Only 'HTML5 Canvas' differs; other formats pass through unchanged.
 *
 * @param destFormat - User-facing destination format name
 * @returns Backend format identifier
 */
export function normalizeDestinationFormat(destFormat: string): string {
  if (destFormat.toLowerCase() === HTML5_CANVAS_FORMAT) {
    return 'HTML5Canvas';
  }

  return destFormat;
}

/**
 * Resolves the file extension for the destination format.
 *
 * @param destinationFormat - User-facing destination format name
 * @returns Lower-case file extension without a dot
 */
export function resolveOutputExtension(destinationFormat: string): string {
  if (destinationFormat.toLowerCase() === HTML5_CANVAS_FORMAT) {
    return 'html';
  }

  return destinationFormat.toLowerCase();
}

/**
 * Builds the output file name by replacing the original extension
 * with the one matching the destination format.
 *
 * @param originalFileName - Source file name, with or without an extension
 * @param destinationFormat - User-facing destination format name
 * @returns File name with the destination-format extension
 */
export function buildOutputFileName(
  originalFileName: string,
  destinationFormat: string
): string {
  const extension = resolveOutputExtension(destinationFormat);
  const dotIndex = originalFileName.lastIndexOf('.');
  const nameWithoutExtension =
    dotIndex > 0 ? originalFileName.slice(0, dotIndex) : originalFileName;
  return `${nameWithoutExtension}.${extension}`;
}
